import { useState, useEffect } from "react";
import { api } from "@/contexts/AuthContext";
import { Music2, Video, Image, ShoppingCart, Mail } from "lucide-react";

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats").then(r => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { icon: Music2, label: "Music Tracks", key: "music", color: "#D4AF37" },
    { icon: Video, label: "Videos", key: "videos", color: "#8B0000" },
    { icon: Image, label: "Images", key: "images", color: "#B22222" },
    { icon: ShoppingCart, label: "Store Products", key: "products", color: "#D4AF37" },
    { icon: Mail, label: "Messages", key: "contacts", color: "#8B0000" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-heading text-3xl mb-1">DASHBOARD</h1>
      <p className="text-white/40 text-sm mb-8">Content management overview</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        {cards.map((card) => (
          <div key={card.key} className="bg-[#111111] border border-white/5 p-5 rounded hover:border-white/10 transition-colors">
            <div className="flex items-center justify-between mb-3">
              <card.icon className="w-5 h-5" style={{ color: card.color }} />
              <span className="font-heading text-3xl">{stats?.[card.key] ?? "—"}</span>
            </div>
            <p className="text-xs text-white/40 uppercase tracking-wider">{card.label}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 bg-[#111111] border border-white/5 p-6 rounded">
        <h2 className="font-heading text-xl mb-3">QUICK GUIDE</h2>
        <ul className="space-y-2 text-sm text-white/50">
          <li>Use the sidebar to manage your content sections.</li>
          <li><strong className="text-[#D4AF37]">Music</strong> — Add tracks with cover art, streaming links, and store pricing.</li>
          <li><strong className="text-[#D4AF37]">Videos</strong> — Add YouTube videos with custom thumbnails.</li>
          <li><strong className="text-[#D4AF37]">Images</strong> — Upload and organize photos by type (hero, artwork, artist).</li>
          <li><strong className="text-[#D4AF37]">Homepage</strong> — Edit hero, about, label, and contact sections.</li>
          <li><strong className="text-[#D4AF37]">Store</strong> — Manage digital products for sale.</li>
          <li><strong className="text-[#D4AF37]">Settings</strong> — Change your admin password.</li>
        </ul>
      </div>
    </div>
  );
}
